(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-mobile"] && !Shopify.designMode) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.querySelector('.shopify-section__header-mobile');
            this.header_2 = document.querySelector('.shopify-section__header-mobile .header-mobile');
            this.headerBounds = {};
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.stickyHeaderType = this.getAttribute('data-sticky-type');

            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;

            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();

            this.setHeaderHeight();
            window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));
            this.backgroundTransparent();
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        setHeaderHeight() {
            if(document.querySelector('.section-header-single-line')) {
                this.header.style.setProperty('--header-height', `${this.header_2.offsetHeight}px`);
            } else {
                if(document.querySelector('.header-mobile-style-full')) {
                    if(document.querySelector('.header-mobile.header-transparent')) {
                        this.header.style.setProperty('--header-height', `calc(${this.header_2.offsetHeight}px + 40px)`);
                    } else {
                        this.header.style.setProperty('--header-height', `calc(${this.header.offsetHeight}px + 40px)`);
                    }
                } else {
                    if(document.querySelector('.header-mobile.header-transparent')) {
                        this.header.style.setProperty('--header-height', `${this.header_2.offsetHeight}px`);
                    } else {
                        this.header.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
                    }
                }
            }
        }

        backgroundTransparent() {
            if (document.querySelector('.header-mobile.header-transparent')) {
                this.header.classList.add('enable-bg-transparent');
            }
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if(!document.body.classList.contains('open-search')){
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);

                    this.isScrolling = setTimeout(() => {
                        this.preventReveal = false;
                    }, 66);

                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                requestAnimationFrame(this.reset.bind(this));
            }

            this.currentScrollTop = scrollTop;
        }

        hide() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    document.body.classList.add('scroll-down');
                    document.body.classList.remove('scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
            this.closeMenuDisclosure();
            this.closeDropdownPopup();
        }

        reveal() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    this.header.classList.remove('shopify-section-header-hidden');
                    document.body.classList.add('scroll-up');
                    document.body.classList.remove('scroll-down');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
        }

        reset() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-down', 'scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-up');
                    return
                }
            }
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }

        closeDropdownPopup() {
            if(this.querySelector('.dropdown-language-currency')){
                this.querySelector('.dropdown-language-currency').classList.remove('show');
            }
        }
    }

    customElements.define('sticky-header-mobile', StickyHeaderMobile);

    document.querySelector('[data-mobile-menu]').addEventListener('click', () => {
        document.body.classList.toggle('menu-open');
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-basic"] && !Shopify.designMode) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.querySelector('.section-header-navigation');
            this.header_2 = document.querySelector('.section-header-navigation .header-nav-basic');
            this.headerBounds = {};
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.headerName = document.querySelector('.shopify-section__header-nav-basic');
            this.stickyHeaderType = this.getAttribute('data-sticky-type');

            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;

            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();

            this.setHeaderHeight();
            window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));
            this.backgroundTransparent();
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        setHeaderHeight() {
            document.querySelector('.section-header-single-line') || this.headerName.querySelector('.transparent') ? this.headerName.style.setProperty('--header-height', `${this.header_2.offsetHeight}px`) : this.headerName.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        backgroundTransparent() {
            if (this.headerName.querySelector('.transparent')) {
                this.headerName.classList.add('enable-bg-transparent');
            }
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if(!document.body.classList.contains('open-search')){
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);

                    this.isScrolling = setTimeout(() => {
                        this.preventReveal = false;
                    }, 66);

                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                requestAnimationFrame(this.reset.bind(this));
            }

            this.currentScrollTop = scrollTop;
        }

        hide() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    document.body.classList.add('scroll-down');
                    document.body.classList.remove('scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
            this.closeMenuDisclosure();
            this.closeDropdownPopup();
        }

        reveal() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    this.header.classList.remove('shopify-section-header-hidden');
                    document.body.classList.add('scroll-up');
                    document.body.classList.remove('scroll-down');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
        }

        reset() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-down', 'scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-up');
                    return
                }
            }
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }

        closeDropdownPopup() {
            if(this.querySelector('.dropdown-language-currency')){
                this.querySelector('.dropdown-language-currency').classList.remove('show');
            }
        }
    }

    customElements.define('sticky-header-basic', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-classic"] && !Shopify.designMode) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.querySelector('.section-header-navigation');
            this.header_2 = document.querySelector('.section-header-navigation .header-nav-classic');
            this.headerBounds = {};
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.headerName = document.querySelector('.shopify-section__header-nav-classic');
            this.stickyHeaderType = this.getAttribute('data-sticky-type');

            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;

            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();

            this.setHeaderHeight();
            window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));
            this.backgroundTransparent();
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        setHeaderHeight() {
            document.querySelector('.section-header-single-line') || this.headerName.querySelector('.transparent') ? this.headerName.style.setProperty('--header-height', `${this.header_2.offsetHeight}px`) : this.headerName.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        backgroundTransparent() {
            if (this.headerName.querySelector('.transparent')) {
                this.headerName.classList.add('enable-bg-transparent');
            }
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if(!document.body.classList.contains('open-search')){
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);

                    this.isScrolling = setTimeout(() => {
                        this.preventReveal = false;
                    }, 66);

                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                requestAnimationFrame(this.reset.bind(this));
            }

            this.currentScrollTop = scrollTop;
        }

        hide() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    document.body.classList.add('scroll-down');
                    document.body.classList.remove('scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
            this.closeMenuDisclosure();
            this.closeDropdownPopup();
        }

        reveal() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    this.header.classList.remove('shopify-section-header-hidden');
                    document.body.classList.add('scroll-up');
                    document.body.classList.remove('scroll-down');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
        }

        reset() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-down', 'scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-up');
                    return
                }
            }
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }

        closeDropdownPopup() {
            if(this.querySelector('.dropdown-language-currency')){
                this.querySelector('.dropdown-language-currency').classList.remove('show');
            }
        }
    }

    customElements.define('sticky-header-classic', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.querySelector('.section-header-navigation');
            this.header_2 = document.querySelector('.section-header-navigation .header-nav-multi-site');
            this.headerBounds = {};
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.headerName = document.querySelector('.shopify-section__header-nav-multi-site');
            this.stickyHeaderType = this.getAttribute('data-sticky-type');

            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;

            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();

            this.setHeaderHeight();
            window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));
            this.backgroundTransparent();
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        setHeaderHeight() {
            document.querySelector('.section-header-single-line') || this.headerName.querySelector('.transparent') ? this.headerName.style.setProperty('--header-height', `${this.header_2.offsetHeight}px`) : this.headerName.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        backgroundTransparent() {
            if (this.headerName.querySelector('.transparent')) {
                this.headerName.classList.add('enable-bg-transparent');
            }
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if(!document.body.classList.contains('open-search')){
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);

                    this.isScrolling = setTimeout(() => {
                        this.preventReveal = false;
                    }, 66);

                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                requestAnimationFrame(this.reset.bind(this));
            }

            this.currentScrollTop = scrollTop;
        }

        hide() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    document.body.classList.add('scroll-down');
                    document.body.classList.remove('scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
            this.closeMenuDisclosure();
            this.closeDropdownPopup();
        }

        reveal() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    this.header.classList.remove('shopify-section-header-hidden');
                    document.body.classList.add('scroll-up');
                    document.body.classList.remove('scroll-down');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
        }

        reset() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-down', 'scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-up');
                    return
                }
            }
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }

        closeDropdownPopup() {
            if(this.querySelector('.dropdown-language-currency')){
                this.querySelector('.dropdown-language-currency').classList.remove('show');
            }
        }
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-vertical-menu"] && !Shopify.designMode) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.querySelector('.section-header-navigation');
            this.header_2 = document.querySelector('.section-header-navigation .shopify-section__header-nav-vertical-menu');
            this.headerBounds = {};
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.headerName = document.querySelector('.shopify-section__header-nav-vertical-menu');
            this.stickyHeaderType = this.getAttribute('data-sticky-type');

            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;

            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
            this.setHeaderHeight();
            window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        setHeaderHeight() {
            document.querySelector('.section-header-single-line') ? this.headerName.style.setProperty('--header-height', `${this.header_2.offsetHeight}px`) : this.headerName.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if(!document.body.classList.contains('open-search')){
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);

                    this.isScrolling = setTimeout(() => {
                        this.preventReveal = false;
                    }, 66);

                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                requestAnimationFrame(this.reset.bind(this));
            }

            this.currentScrollTop = scrollTop;
        }

        hide() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    document.body.classList.add('scroll-down');
                    document.body.classList.remove('scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
            this.closeMenuDisclosure();
            this.closeDropdownPopup();
        }

        reveal() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    this.header.classList.remove('shopify-section-header-hidden');
                    document.body.classList.add('scroll-up');
                    document.body.classList.remove('scroll-down');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
        }

        reset() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-down', 'scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-up');
                    return
                }
            }
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }

        closeDropdownPopup() {
            if(this.querySelector('.dropdown-language-currency')){
                this.querySelector('.dropdown-language-currency').classList.remove('show');
            }
        }
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.querySelector('.section-header-navigation');
            this.header_2 = document.querySelector('.section-header-navigation .header-nav-full-elements');
            this.headerBounds = {};
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.headerName = document.querySelector('.shopify-section__header-nav-full-elements');
            this.stickyHeaderType = this.getAttribute('data-sticky-type');

            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;

            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();

            this.setHeaderHeight();
            window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));
            this.backgroundTransparent();
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        setHeaderHeight() {
            document.querySelector('.section-header-single-line') || this.headerName.querySelector('.transparent') ? this.headerName.style.setProperty('--header-height', `${this.header_2.offsetHeight}px`) : this.headerName.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        backgroundTransparent() {
            if (this.headerName.querySelector('.transparent')) {
                this.headerName.classList.add('enable-bg-transparent');
            }
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if(!document.body.classList.contains('open-search')){
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);

                    this.isScrolling = setTimeout(() => {
                        this.preventReveal = false;
                    }, 66);

                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                requestAnimationFrame(this.reset.bind(this));
            }

            this.currentScrollTop = scrollTop;
        }

        hide() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    document.body.classList.add('scroll-down');
                    document.body.classList.remove('scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
            this.closeMenuDisclosure();
            this.closeDropdownPopup();
        }

        reveal() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    this.header.classList.remove('shopify-section-header-hidden');
                    document.body.classList.add('scroll-up');
                    document.body.classList.remove('scroll-down');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
        }

        reset() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-down', 'scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-up');
                    return
                }
            }
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }

        closeDropdownPopup() {
            if(this.querySelector('.dropdown-language-currency')){
                this.querySelector('.dropdown-language-currency').classList.remove('show');
            }
        }
    }

    customElements.define('sticky-header-full-elements', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header');
            this.headerBounds = {};
            this.currentScrollTop = 0;
            this.preventReveal = false;

            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;

            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if(!document.body.classList.contains('open-search')){
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);

                    this.isScrolling = setTimeout(() => {
                        this.preventReveal = false;
                    }, 66);

                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                requestAnimationFrame(this.reset.bind(this));
            }

            this.currentScrollTop = scrollTop;
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.closeMenuDisclosure();
            this.closeDropdownPopup();
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }

        closeDropdownPopup() {
            if(this.querySelector('.dropdown-language-currency')){
                this.querySelector('.dropdown-language-currency').classList.remove('show');
            }
        }
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
    class CartNote extends HTMLElement {
        constructor() {
            super();

            this.addEventListener('change', debounce((event) => {
                const body = JSON.stringify({ note: event.target.value });
                fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
            }, 300))
        }
    }

    customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
